
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.89 0H1.104C.495 0 0 .495 0 1.103v2.23c0 .339.118.67.332.933l7.76 9.524a.778.778 0 01.175.49v8.992c0 .254.129.485.345.619a.725.725 0 00.707.032l2.798-1.4c.376-.188.61-.566.61-.986V14.28c0-.178.062-.352.175-.49l7.76-9.524c.214-.263.332-.594.332-.934V1.103C20.994.495 20.499 0 19.89 0zm-7.866 14.28v7.257c0 .152-.085.29-.221.358l-2.798 1.399c-.005.002-.012.006-.024-.001-.011-.007-.011-.016-.011-.02V14.28l-.001-.05h3.056v.05zm8.267-11.274h-1.152a.351.351 0 100 .703h1.054a.77.77 0 01-.077.113l-7.76 9.524a1.478 1.478 0 00-.126.181H8.763a1.479 1.479 0 00-.126-.181L.877 3.822a.77.77 0 01-.076-.113h1.054a.352.352 0 100-.703H.703V1.103c0-.22.18-.4.4-.4h18.788c.22 0 .4.18.4.4v1.903z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M17.636 3.006H3.358a.352.352 0 100 .703h14.278a.351.351 0 100-.703z","fill":"#E2E4EC"}})])
          )
        }
      }
    